import React from "react";
import BookStore from "../../stores/book-store";

export default class PageNumberForm extends React.Component {
  constructor() {
    super();
    this.state = {
      pageError: false
    };
    this._goToPageKeyUp = this._goToPageKeyUp.bind(this);
    this._goToPageKeyUpCallback = this._goToPageKeyUpCallback.bind(this);
    this._goToPageClick = this._goToPageClick.bind(this);
  }

  componentWillUnmount() {
    clearTimeout(this.pageErrorTimeout);
    clearInterval(this.pageErrorFadeoutInterval);
  }

  _goToPageClick() {
    this.pageInput.select();
  }

  _goToPageKeyUp(e) {
    e.preventDefault();
    e.stopPropagation();
    if (e.keyCode === 13) {
      const page = this.props.page;
      const book = BookStore.get(this.props.isbn);
      book.goTo({ page, callback: this._goToPageKeyUpCallback }); // TODO:: awful callback name
    }
  }

  _goToPageKeyUpCallback(data) {
    const page = this.props.page;
    if (data.message && data.message === "page not found") {
      // Uh oh, invalid page
      this.setState(
        { pageError: i18n.t("reader.page-dne", { page }), opacity: 1 },
        () => {
          clearTimeout(this.pageErrorTimeout);
          clearInterval(this.pageErrorFadeoutInterval);
          this.pageErrorTimeout = setTimeout(() => {
            this.pageErrorFadeoutIntervalCount = 0;
            this.pageErrorFadeoutInterval = setInterval(() => {
              if (this.pageErrorFadeoutIntervalCount === 9) {
                clearInterval(this.pageErrorFadeoutInterval);
                this.setState({ pageError: false, opacity: 0 });
              } else {
                this.pageErrorFadeoutIntervalCount += 1;
                this.setState(ps => {
                  let opacity = ps.opacity - 0.1;
                  if (opacity < 0) {
                    opacity = 0;
                  }
                  return { opacity };
                });
              }
            }, 25);
          }, 2500);
        }
      );
      Fraction.Helpers.removeLoader("#jigsaw-placeholder-outer");
    } else {
      this.pageInput.blur();
      $("#jigsaw-placeholder-outer > iframe").focus();
      if (page) {
        this.props.updatePageNumber(page);
        this.props.setPageAndDefaultPage(page);
      }
    }
    this.props.goToPageBlur();
    Fraction.Reporter.gaEvent(
      "reader/navigation/goToPage",
      "page: " + page + " (" + data.message + ")"
    );
  }

  render() {
    return (
      <div id="go-to-page-wrapper">
        <form id="go-to-page-form" onSubmit={this._goToPageKeyUp}>
          <label htmlFor="go-to-page" className="go-to-page-label">
            {i18n.t("reader.go-to-page")}
          </label>
          <input
            type="text"
            id="go-to-page"
            ref={input => {
              this.pageInput = input;
            }}
            value={this.props.page}
            onChange={this.props.goToPageChange}
            onClick={this._goToPageClick}
            onKeyUp={this._goToPageKeyUp}
            onBlur={this.props.goToPageBlur}
          />
        </form>
        {this.state.pageError && (
          <div
            id="notification-container"
            style={{ opacity: this.state.opacity }}
          >
            <div
              id="errorMessage"
              role="alert"
              tabIndex="0"
              className="floater error"
            >
              {this.state.pageError}
              <div className="pointer down" />
            </div>
          </div>
        )}
      </div>
    );
  }
}
